module.exports = __webpack_public_path__ + "static/media/sun.97e970d7.svg";